import api from '_config/travel';
import format from "date-fns/format";

export async function getFlights(data) {
    const {
        currentPage,
        departure,
        arrival,
        dates,
        passengers,
        cabinClass,
        onlyDeparture,
        customer_uuid,
        filter,
        order
    } = data;

    const departureDate = format(dates.startDate, "yyyy-MM-dd");
    const returnDate = !onlyDeparture && dates.endDate ? format(dates.endDate, "yyyy-MM-dd") : null;

    let sort = "lowest_price";

    if (order === 'price-desc') {
        sort = 'highest_price'
    } else if (order === 'duration-asc') {
        sort = 'duration'
    } else if (order === 'outbound-asc') {
        sort = 'departure_date'
    } else if (order === 'airline-asc') {
        sort = 'company'
    }

    const params = new URLSearchParams({
        'departure_code': departure.code ? departure.code : departure,
        'arrival_code': arrival.code ? arrival.code : arrival,
        'departure_date': departureDate,
        type: onlyDeparture ? 2 : 1,
        cabin: cabinClass,
        adults: passengers.adults,
        children: passengers.children,
        baby: passengers.infants,
        page: currentPage,
        per_page: 20,
        sort,
    });

    if (departure.code) {
        params.append('customer_uuid', customer_uuid ? btoa(customer_uuid) : '');
        params.append('departure[name]', decodeURIComponent(departure.name));
        params.append('departure[code]', departure.code);
        params.append('departure[main_code]', departure.mainCode);
        params.append('departure[country_code]', departure.countryCode);
        params.append('departure[city_name]', departure.cityName);
        params.append('departure[value]', decodeURIComponent(departure.value));
        params.append('departure[is_city]', departure.isCity ? 1 : 0);
    }

    if (arrival.code) {
        params.append('arrival[name]', decodeURIComponent(arrival.name));
        params.append('arrival[code]', arrival.code);
        params.append('arrival[main_code]', arrival.mainCode);
        params.append('arrival[country_code]', arrival.countryCode);
        params.append('arrival[city_name]', arrival.cityName);
        params.append('arrival[value]', decodeURIComponent(arrival.value));
        params.append('arrival[is_city]', arrival.isCity ? 1 : 0);
    }

    if (!onlyDeparture) {
        params.append('arrival_date', returnDate);
    }

    if (filter.baggage && filter.baggage !== 'all') {
        params.append('baggage', filter.baggage === 'hand' ? 2 : 1);
    }

    if (filter.stops && filter.stops.length) {
        params.append('stops[]', filter.stops);
        
    }

    if (filter.airlines && filter.airlines.length) {
        filter.airlines.forEach(item => params.append('company_code[]', item));
    }

    if (filter.priceMin || filter.priceMax) {
        params.append('points_range[min]', filter.priceMin ? Number(filter.priceMin) : 0);
        params.append('points_range[max]', filter.priceMax ? Number(filter.priceMax) : 99999999);
    }

    if (filter.outboundTimes && filter.outboundTimes.length) {
        filter.outboundTimes.forEach(item => params.append('departure_schedule[]', item));
    }

    if (filter.inboundTimes && filter.inboundTimes.length) {
        filter.inboundTimes.forEach(item => params.append('return_schedule[]', item));
    }

    return api.get('/flights/recommendation/', { params })
        .then(response => {
            return { data: response.data, status: true };
        })
        .catch(error => {
            console.error('Error fetching flights:', error);
            return { status: false };
        });
}

export async function chooseFlight(data) {
    const { searchId, recommendationId, departureId, returnId } = data;

    const payload = {
        search_id: searchId,
        recommendation_id: recommendationId,
        departure_id: departureId,
    };

    if (returnId) {
        payload.return_id = returnId;
    }

    return api.post('/flights/choose', payload)
        .then(response => {
            return { data: response.data, status: true };
        })
        .catch(error => {
            console.error('Error choosing flight:', error);
            return { status: false };
        });
}

export async function sendPassengers(data) {
    const { chooseId, passengers } = data;

    const payload = {
        choose_id: chooseId,
        passengers,
    };

    return api.post('/flights/passengers', payload)
        .then(response => {
            return { data: response.data, status: true };
        })
        .catch(error => {
            console.error('Error sending passengers:', error);
            const message = error?.response?.data?.message || '';
            return { status: false, message, code: error?.response?.status };
        });
}

export async function getChoosenFlight(chooseId) {
    return api.get(`/flights/choosen-flights/${chooseId}`)
        .then(response => {
            return { data: response.data, status: true };
        })
        .catch(error => {
            console.error('Error fetching choosen flight:', error);
            return { status: false };
        });
}

export async function getPricing(chooseId) {
    return api.get('/flights/pricing', { params: { choose_id: chooseId } })
        .then(response => {
            return { data: response.data, status: true };
        })
        .catch(error => {
            console.error('Error fetching pricing:', error);
            return { status: false };
        });
}
